import { css } from "emotion";

export const wrapper = css({
  display: "flex"
});

export const selectStyle = css({
  width: "80px",
  marginBottom: 0
});

export const combinedLabelStyle = css({
  zIndex: 1
});
